import cookies from '../../constants/cookies';
import events from '../../constants/events';
import { dispatchEvent } from '../../utilities/customEvents';

import { Base } from './Base';

import Cookies from 'js-cookie';

const { locations } = window.mosmosh;

export class LocationPopupTrigger extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.checkCookie();
  }

  checkCookie() {
    const locationPopupCookie = Cookies.get(cookies.SELECTED_LOCATION);
    if (!locationPopupCookie) {
      this.determineLocation();
    }
  }

  determineLocation() {
    fetch('https://get.geojs.io/v1/ip/country.json')
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        const { country: country_code2 } = json;
        let countryFound = false;
        if (country_code2) {

          // Loop through locations to find a match
          for (let i = 0; i < locations.length; i++) {
            const location = locations[i];

            if (location.country_code === country_code2) {
              countryFound = true;

              // Set Mos Mosh location object
              window.mosmosh.location = location;

              Cookies.set(cookies.SELECTED_LOCATION, location.country_code, { expires: 1 });
              dispatchEvent(window, events.LOCATION_SET);

              // Country if found but doesn't match current URL
              if (!location.url.includes(window.location.host)) {
                this.openOverlay();
                break;
              }
            }
          };

          if (!countryFound) {
            this.openOverlay();
          }
        }
      });
  }

  openOverlay() {
    const options = {};
    options.target = '#location-popup';
    options.variants = 'ss-overlay--transparent';
    options.preventClose = true;

    dispatchEvent(window, events.OPEN_OVERLAY, options);
  }

  getCurrentPage() {
    return window.location.pathname.split('/').pop();
  }
}
